import {
    getToken,
    getUser,
} from "../../Utils/Common";
import { getAPICall } from "../axiosMethodCalls";

export const getSupplierPrices = async (data) => {
    try {
        const response = await getAPICall(
            process.env.REACT_APP_LINK + "supplier_prices/compare",
            {
                requester: getUser(),
                token: getToken(),
                brand: data.brand_id,
                item_id: data.item_id,
                supplier_id: data.supplier_id,
            }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error };
    }
};